import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { fetchCompanies as fetchCompaniesAction } from './actions';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { getErrorCode } from 'store/utils';

export const fetchCompanies: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(fetchCompaniesAction.request)),
    withLatestFrom(state$),
    mergeMap(([{ payload }, state]) => {
      return apiClient(state)
        .fetchCompanyFilterOptions(payload)
        .pipe(
          map(({ response }) => fetchCompaniesAction.success({ companies: response, params: payload })),
          catchError((error: Error) => of(fetchCompaniesAction.failure({ error, errorCode: getErrorCode(error) }))),
        );
    }),
  );
